import { TableColumn } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { EntityRefLink } from '@backstage/plugin-catalog-react';

export const pagerDutyTeamColumns: TableColumn<CatalogTableRow>[] = [
  {
    title: 'Name',
    field: 'resolved.entityRef',
    highlight: true,
    render: ({ entity }) => (
      <EntityRefLink entityRef={entity} defaultKind="component">
        {entity.metadata.title ?? entity.metadata.name}
      </EntityRefLink>
    ),
  },
  {
    title: 'Owner',
    field: 'entity.spec.owner',
    render: ({ entity }) => {
      const owner = (entity.spec as { owner?: unknown } | undefined)?.owner;
      if (typeof owner !== 'string' || !owner || owner === 'unknown') {
        return <>—</>;
      }
      return (
        <EntityRefLink
          entityRef={{ kind: 'Group', namespace: 'default', name: owner }}
        />
      );
    },
  },
  {
    title: 'Description',
    field: 'entity.metadata.description',
    render: ({ entity }) => <>{entity.metadata.description || '—'}</>,
  },
];
